import { useFeatures } from '@api/application-configuration';
import { UnistocksFeatures } from '@unistocks/shared/features';
import { isTrue } from '@unistocks/shared/utils/util';

/**
 * Returns whether a feature is enabled.
 * @param feature The feature to check.
 * @returns True if the feature is enabled, false otherwise.
 */
export const useFeatureEnabled = (feature: string) => {
  const features = useFeatures();

  return features ? isTrue(features[feature]) : false;
};

export const useDevToolsEnabled = () => useFeatureEnabled(UnistocksFeatures.DevTools) || __DEV__;
